import { CalculateFinalPrice } from "../metadata/CalculatePrice";

export function GetSoftwareMetaBonus(services, masters, serviciosCatalogo) {
  try {
    if (!Array.isArray(services) || services.length === 0) return 0;

    let totalVendido = 0;

    for (const service of services) {
      const finalPrice = CalculateFinalPrice(service, serviciosCatalogo);
      totalVendido += finalPrice;
    }

    const metaCumplida = masters
      .filter(
        (r) =>
          r.category === "Software" &&
          r.fixedGoal &&
          totalVendido >= r.fixedGoal
      )
      .sort((a, b) => b.fixedGoal - a.fixedGoal)[0];

    return metaCumplida?.fixedCommission || 0;
  } catch (e) {
    return 0;
  }
}
